import { render, staticRenderFns } from "./send-product-payment-request-message.vue?vue&type=template&id=6de1c29b&scoped=true&"
import script from "./send-product-payment-request-message.vue?vue&type=script&lang=ts&"
export * from "./send-product-payment-request-message.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de1c29b",
  null
  
)

export default component.exports